import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import i18n from "../../../language/i18n";
import { normalizeLang } from "../../../utils/localeDataLoader";
import {
  filterIntroduceCardsBySubtitle,
  INTRODUCE_CARD_GROUPS,
  useIntroduceCultureQuery,
  useIntroduceOverviewCardsQuery,
} from "hooks";
import IntroduceCardGrid from "./IntroduceCardGrid";
import IntroduceSectionTitle from "./IntroduceSectionTitle";
import IntroduceStandaloneLayout from "./IntroduceStandaloneLayout";

function IntroduceCulture() {
  useTranslation();
  const location = useLocation();
  const currentLang = normalizeLang(i18n.language);
  const isStandalone = /^\/(tuyen-dung|recruitment)(\/|$)/.test(
    location.pathname,
  );
  const {
    data: cultureData,
    isLoading: loading,
    error,
  } = useIntroduceCultureQuery(currentLang);

  const { data: overviewCards = [] } =
    useIntroduceOverviewCardsQuery(currentLang);
  const cultureCards = filterIntroduceCardsBySubtitle(
    overviewCards,
    INTRODUCE_CARD_GROUPS.cultureWorkplace,
  );
  if (loading) return <div>Loading...</div>;

  if (error) {
    return (
      <div style={{ color: "red", textAlign: "center", padding: "20px" }}>
        {currentLang === "vi"
          ? "Không thể tải dữ liệu. Vui lòng thử lại sau."
          : "Unable to load data. Please try again later."}
      </div>
    );
  }

  if (!cultureData) {
    return (
      <div>
        {currentLang === "vi" ? "Không có dữ liệu." : "No data available."}
      </div>
    );
  }

  const content = (
    <div className="IntroduceCulture">
      <IntroduceSectionTitle>
        {currentLang === "vi"
          ? "Văn hóa và môi trường làm việc"
          : "Culture and work environment"}
      </IntroduceSectionTitle>
      {cultureData.description && (
        <blockquote className="culture-quote">
          <div
            className="culture-description quill-content"
            dangerouslySetInnerHTML={{ __html: cultureData.description }}
          />
        </blockquote>
      )}
      <IntroduceCardGrid cards={cultureCards} className="culture-card-grid" />
    </div>
  );

  if (!isStandalone) return content;

  return (
    <IntroduceStandaloneLayout
      eyebrow={currentLang === "vi" ? "TUYỂN DỤNG HSV" : "CAREERS AT HSV"}
      title={
        currentLang === "vi"
          ? "Văn hóa và môi trường làm việc"
          : "Culture and work environment"
      }
      description={
        currentLang === "vi"
          ? "Khám phá giá trị, tinh thần cộng tác và môi trường phát triển tại HSV."
          : "Explore HSV's values, collaborative spirit and growth environment."
      }
    >
      {content}
    </IntroduceStandaloneLayout>
  );
}

export default IntroduceCulture;
